module.exports = __webpack_public_path__ + "static/img/icon3.37c8920f.png";